import HomeCard from "../HomeCard";
import "./HomeCardCity.css";

const HomeCardCity = () => {
    return <HomeCard className={"home-card-city"} itemType={"zep"} itemKey={0} itemName="한국도시설계학회 메타버스" itemDesc="도시의 치유와 발전을 위한 목소리, ZEP에서 펼치다" />
};

export default HomeCardCity;
